import { INSTRUCTOR_CATEGORIES } from '../data/instructorCategories';
import baseScmService from 'services/baseScmService';

const sbatGroupInstructorService = baseScmService.injectEndpoints({
  endpoints: (build) => ({
    updateSbatGroupInstructors: build.mutation({
      query: ({ sbatGroupId, instructors }) => ({
        method: 'PUT',
        url: `/sbat-group-instructors/bulk-update`,
        body: {
          sbat_group_id: sbatGroupId,
          sbat_group_instructors: [
            instructors.primary?.value && {
              instructor_id: instructors.primary?.value,
              category: INSTRUCTOR_CATEGORIES.primary,
            },
            instructors.secondary?.value && {
              instructor_id: instructors.secondary?.value,
              category: INSTRUCTOR_CATEGORIES.secondary,
            },
            ...instructors?.other?.map((instructor) => ({
              instructor_id: instructor?.value,
              category: INSTRUCTOR_CATEGORIES.other,
            })),
          ],
        },
      }),
      invalidatesTags: (result, error, { sbatGroupId }) =>
        error ? [] : [{ type: 'SbatGroup', id: sbatGroupId }],
    }),
    bulkUpdateSbatGroupInstructors: build.mutation({
      query: ({ sbatGroupIds, sbatGroupInstructors }) => ({
        method: 'PUT',
        url: '/sbat-group-instructors/bulk-update-instructors',
        body: {
          sbat_group_ids: sbatGroupIds,
          sbat_group_instructors: sbatGroupInstructors?.map((instructor) => ({
            instructor_id: instructor.value,
            category: instructor.category,
          })),
        },
      }),
      invalidatesTags: (result, error, { sbatGroupIds }) => {
        const sbatGroupTags = sbatGroupIds.map((sbatGroupId) => ({
          type: 'SbatGroup',
          id: sbatGroupId,
        }));
        return error ? [] : [...sbatGroupTags];
      },
    }),
  }),
  overrideExisting: false,
});

export const {
  useUpdateSbatGroupInstructorsMutation,
  useBulkUpdateSbatGroupInstructorsMutation,
} = sbatGroupInstructorService;

export default sbatGroupInstructorService;
